import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteLayout } from "./components/site/SiteLayout";
import Landing from "./pages/Landing";
import Join from "./pages/Join";
import VerifyEmail from "./pages/VerifyEmail";
import Dashboard from "./pages/Dashboard";
import { Unsubscribe, EmailPreferences, FaqPage } from "./pages/UserPages";
import { Privacy, Terms } from "./pages/Legal";
import AdminLayout from "./components/admin/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminWaitlist from "./pages/admin/AdminWaitlist";
import AdminExports from "./pages/admin/AdminExports";
import AdminTemplates from "./pages/admin/AdminTemplates";
import AdminCampaigns from "./pages/admin/AdminCampaigns";
import AdminApprovals from "./pages/admin/AdminApprovals";
import AdminDeliveryLogs from "./pages/admin/AdminDeliveryLogs";
import AdminSettings from "./pages/admin/AdminSettings";

const isField = (el) => el?.closest?.("input, textarea, [contenteditable='true']");

function App() {
  useEffect(() => {
    const ctx = (e) => { if (!isField(e.target)) e.preventDefault(); };
    const keys = (e) => {
      const k = e.key?.toUpperCase();
      const mod = e.ctrlKey || e.metaKey;
      if (k === "F12" || (mod && e.shiftKey && ["I", "J", "C"].includes(k)) || (mod && e.altKey && ["I", "J", "C"].includes(k)) || (mod && k === "U")) e.preventDefault();
    };
    document.addEventListener("contextmenu", ctx);
    document.addEventListener("keydown", keys);
    return () => { document.removeEventListener("contextmenu", ctx); document.removeEventListener("keydown", keys); };
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/join" element={<Join />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/email-preferences" element={<EmailPreferences />} />
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="waitlist" element={<AdminWaitlist />} />
            <Route path="exports" element={<AdminExports />} />
            <Route path="email-templates" element={<AdminTemplates />} />
            <Route path="campaigns" element={<AdminCampaigns />} />
            <Route path="approvals" element={<AdminApprovals />} />
            <Route path="delivery-logs" element={<AdminDeliveryLogs />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
